import React, { FC, useEffect, useState } from 'react';

import {
	ArrayElement, Checkbox, Counter,
	IColumnEditor, Label, Menu,
} from '@aleph/shared-components';
import { getRedditCarrierOptions } from 'wb-reddit/app/routes/superGrid/targeting/utils';
import { useApolloClient } from '@apollo/client';
import { CarrierOptionsQuery } from 'wb-reddit/graphql/generated';
import { Loader } from 'rsuite';

const CarriersColumnEditor: FC<IColumnEditor<CarrierOptionsQuery['options']['items']>> = (params) => {
	const {
		value, setValue, editorContext, setEditorContext,
	} = params;
	const client = useApolloClient();

	const [loading, setLoading] = useState<boolean>(true);
	const [options, setOptions] = useState<CarrierOptionsQuery['options']['items']>([]);

	const getCarriers = async () => {
		setLoading(true);

		const carrierOptions = await getRedditCarrierOptions({
			client,
			search: editorContext?.search,
		});

		setLoading(false);
		setOptions(carrierOptions);
	};

	const toggleValue = (option: ArrayElement<CarrierOptionsQuery['options']['items']>) => () => {
		setEditorContext({
			...editorContext,
			search: '',
		});

		if (value?.some(v => v?.value === option?.value)) {
			setValue(value?.filter(v => v?.value !== option?.value));

			return;
		}

		setValue([
			...(value ?? []),
			option,
		]);
	};

	const toggleAll = () => {
		setValue((value?.length ?? 0) > 0 ? [] : options);
	};

	useEffect(() => {
		if (editorContext) {
			getCarriers();
		}
	}, [editorContext?.search ?? '']);

	return (
		<Menu
			className="p-[8px]"
		>
			<>
				{
					loading
				&& <Loader
					vertical
					size="md"
					className="flex-1 !flex items-center justify-center"
					content="Loading carriers"
				/>
				}

				{!loading
					&& <Menu.Item selected={value?.length === options?.length}
						onClick={toggleAll}
						alignItems="space-between"
					>
						<Label className="text-gray-600 text-[12px]">
							SELECT ALL
						</Label>
						{(value?.length ?? 0) > 0
							&& <Counter
								variant="square-accent"
								className="relative"
								count={value?.length ?? 0}
							/>
						}
						<Checkbox
							onClick={toggleAll}
							partial={(value?.length ?? 0) > 0 && value?.length !== options?.length}
							checked={value?.length === options?.length}
						/>
					</Menu.Item>
				}

				{!loading
					&& value?.map(option => (
						<Menu.Item
							onClick={toggleValue(option)}
							selected={value?.some(v => v?.value === option?.value)}
							alignItems="space-between"
							key={option?.value}
						>
							<Label>{`${option?.label} - ${option?.country}`}</Label>
							<Checkbox checked={value?.some(v => v?.value === option?.value)} />
						</Menu.Item>
					))
				}

				{!loading
					&& options?.filter(option => value?.every(v => v?.value !== option?.value) ?? true)?.map(option => (
						<Menu.Item
							onClick={toggleValue(option)}
							selected={value?.some(v => v?.value === option?.value)}
							alignItems="space-between"
							key={option?.value}
						>
							<Label>{`${option?.label} - ${option?.country}`}</Label>
							<Checkbox checked={value?.some(v => v?.value === option?.value)} />
						</Menu.Item>
					))
				}
			</>
		</Menu>
	);
};

export default CarriersColumnEditor;
